var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _path110, _path111, _path112, _path113, _path114;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePageGameImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 473,
    viewBox: "0 0 329 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 68.6509C288.5 57.6052 297.454 48.6509 308.5 48.6509C319.546 48.6509 328.5 57.6052 328.5 68.6509C328.5 79.6966 319.546 88.6509 308.5 88.6509C297.454 88.6509 288.5 79.6966 288.5 68.6509Z",
    fill: "#90A8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 68.6509C288.5 57.6052 297.454 48.6509 308.5 48.6509C319.546 48.6509 328.5 57.6052 328.5 68.6509C328.5 79.6966 319.546 88.6509 308.5 88.6509C297.454 88.6509 288.5 79.6966 288.5 68.6509Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 116.651C240.5 105.605 249.454 96.6509 260.5 96.6509C271.546 96.6509 280.5 105.605 280.5 116.651C280.5 127.697 271.546 136.651 260.5 136.651C249.454 136.651 240.5 127.697 240.5 116.651Z",
    fill: "#90A8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 116.651C240.5 105.605 249.454 96.6509 260.5 96.6509C271.546 96.6509 280.5 105.605 280.5 116.651C280.5 127.697 271.546 136.651 260.5 136.651C249.454 136.651 240.5 127.697 240.5 116.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M311.477 113.001L304.654 117.701L296.22 106.659M296.22 106.659L296.659 103.892M296.22 106.659L294.351 104.985M296.22 106.659H293.501",
    stroke: "#FE00FE",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311.961 116.888L308.317 125.07L311.961 134.256H308.317",
    stroke: "#FE00FE",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M313.903 116.888L315.968 125.07L313.903 134.256H317.547",
    stroke: "#FE00FE",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.325 101.487C303.292 102.836 300.306 108.008 301.654 113.041L303.56 120.153C303.838 121.19 304.903 121.805 305.94 121.527C307.136 121.206 308.333 120.886 309.529 120.565L316.82 118.612C318.017 118.291 319.213 117.97 320.41 117.65C321.446 117.372 322.062 116.307 321.784 115.27L319.878 108.158C318.53 103.125 313.357 100.139 308.325 101.487Z",
    fill: "#FE00FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309.322 113.037C309.322 113.037 309.989 113.484 311.301 113.132C312.613 112.781 312.968 112.06 312.968 112.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.077,
    cy: 111.976,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 305.077 111.976)",
    fill: "#1F1F23"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.335,
    cy: 111.547,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 304.335 111.547)",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.221,
    cy: 108.99,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 316.221 108.99)",
    fill: "#1F1F23"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.479,
    cy: 108.561,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 315.479 108.561)",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.056 113.244L319.879 117.944L321.207 127.878M321.207 127.878L319.879 129.544M321.207 127.878V130.734M321.207 127.878L323.502 129.544",
    stroke: "#FE00FE",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 164.651C192.5 153.605 201.454 144.651 212.5 144.651C223.546 144.651 232.5 153.605 232.5 164.651C232.5 175.697 223.546 184.651 212.5 184.651C201.454 184.651 192.5 175.697 192.5 164.651Z",
    fill: "#90A8C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 164.651C192.5 153.605 201.454 144.651 212.5 144.651C223.546 144.651 232.5 153.605 232.5 164.651C232.5 175.697 223.546 184.651 212.5 184.651C201.454 184.651 192.5 175.697 192.5 164.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 164.651C288.5 153.605 297.454 144.651 308.5 144.651C319.546 144.651 328.5 153.605 328.5 164.651C328.5 175.697 319.546 184.651 308.5 184.651C297.454 184.651 288.5 175.697 288.5 164.651Z",
    fill: "#90A8C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 164.651C288.5 153.605 297.454 144.651 308.5 144.651C319.546 144.651 328.5 153.605 328.5 164.651C328.5 175.697 319.546 184.651 308.5 184.651C297.454 184.651 288.5 175.697 288.5 164.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 212.651C0.5 201.605 9.45431 192.651 20.5 192.651C31.5457 192.651 40.5 201.605 40.5 212.651C40.5 223.697 31.5457 232.651 20.5 232.651C9.45431 232.651 0.5 223.697 0.5 212.651Z",
    fill: "#90A8C1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 212.651C0.5 201.605 9.45431 192.651 20.5 192.651C31.5457 192.651 40.5 201.605 40.5 212.651C40.5 223.697 31.5457 232.651 20.5 232.651C9.45431 232.651 0.5 223.697 0.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 212.651C48.5 201.605 57.4543 192.651 68.5 192.651C79.5457 192.651 88.5 201.605 88.5 212.651C88.5 223.697 79.5457 232.651 68.5 232.651C57.4543 232.651 48.5 223.697 48.5 212.651Z",
    fill: "#90A8C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 212.651C48.5 201.605 57.4543 192.651 68.5 192.651C79.5457 192.651 88.5 201.605 88.5 212.651C88.5 223.697 79.5457 232.651 68.5 232.651C57.4543 232.651 48.5 223.697 48.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 212.651C96.5 201.605 105.454 192.651 116.5 192.651C127.546 192.651 136.5 201.605 136.5 212.651C136.5 223.697 127.546 232.651 116.5 232.651C105.454 232.651 96.5 223.697 96.5 212.651Z",
    fill: "#90A8C1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 212.651C96.5 201.605 105.454 192.651 116.5 192.651C127.546 192.651 136.5 201.605 136.5 212.651C136.5 223.697 127.546 232.651 116.5 232.651C105.454 232.651 96.5 223.697 96.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.523 209.001L168.346 213.701L176.78 202.659M176.78 202.659L176.341 199.892M176.78 202.659L178.649 200.985M176.78 202.659H179.499",
    stroke: "#00F0FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M161.039 212.888L164.683 221.07L161.039 230.256H164.683",
    stroke: "#00F0FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.097 212.888L157.032 221.07L159.097 230.256H155.453",
    stroke: "#00F0FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.675 197.487C169.708 198.836 172.694 204.008 171.346 209.041L169.44 216.153C169.162 217.19 168.097 217.805 167.06 217.527C165.864 217.206 164.667 216.886 163.471 216.565L156.18 214.612C154.983 214.291 153.787 213.97 152.59 213.65C151.554 213.372 150.938 212.307 151.216 211.27L153.122 204.158C154.47 199.125 159.643 196.139 164.675 197.487Z",
    fill: "#00F0FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M163.678 209.037C163.678 209.037 163.011 209.484 161.699 209.132C160.387 208.781 160.032 208.06 160.032 208.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 169.782 206.903)",
    fill: "#1F1F23"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 169.037 207.333)",
    fill: "#D9D9D9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 158.638 203.917)",
    fill: "#1F1F23"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 157.893 204.346)",
    fill: "#D9D9D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M159.944 209.244L153.121 213.944L151.793 223.878M151.793 223.878L153.121 225.544M151.793 223.878V226.734M151.793 223.878L149.498 225.544",
    stroke: "#00F0FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 212.651C192.5 201.605 201.454 192.651 212.5 192.651C223.546 192.651 232.5 201.605 232.5 212.651C232.5 223.697 223.546 232.651 212.5 232.651C201.454 232.651 192.5 223.697 192.5 212.651Z",
    fill: "#90A8C1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 212.651C192.5 201.605 201.454 192.651 212.5 192.651C223.546 192.651 232.5 201.605 232.5 212.651C232.5 223.697 223.546 232.651 212.5 232.651C201.454 232.651 192.5 223.697 192.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 212.651C240.5 201.605 249.454 192.651 260.5 192.651C271.546 192.651 280.5 201.605 280.5 212.651C280.5 223.697 271.546 232.651 260.5 232.651C249.454 232.651 240.5 223.697 240.5 212.651Z",
    fill: "#90A8C1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 212.651C240.5 201.605 249.454 192.651 260.5 192.651C271.546 192.651 280.5 201.605 280.5 212.651C280.5 223.697 271.546 232.651 260.5 232.651C249.454 232.651 240.5 223.697 240.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 212.651C288.5 201.605 297.454 192.651 308.5 192.651C319.546 192.651 328.5 201.605 328.5 212.651C328.5 223.697 319.546 232.651 308.5 232.651C297.454 232.651 288.5 223.697 288.5 212.651Z",
    fill: "#90A8C1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 212.651C288.5 201.605 297.454 192.651 308.5 192.651C319.546 192.651 328.5 201.605 328.5 212.651C328.5 223.697 319.546 232.651 308.5 232.651C297.454 232.651 288.5 223.697 288.5 212.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4766 257.001L16.6539 261.701L8.22031 250.659M8.22031 250.659L8.65875 247.892M8.22031 250.659L6.35106 248.985M8.22031 250.659H5.50085",
    stroke: "#FF453A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9609 260.888L20.3171 269.07L23.9609 278.256H20.3171",
    stroke: "#FF453A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9032 260.888L27.9679 269.07L25.9032 278.256H29.5469",
    stroke: "#FF453A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3245 245.487C15.2921 246.836 12.3056 252.008 13.6541 257.041L15.5598 264.153C15.8376 265.19 16.9032 265.805 17.9399 265.527C19.1363 265.206 20.3327 264.886 21.5292 264.565L28.8203 262.612C30.0167 262.291 31.2132 261.97 32.4096 261.65C33.4463 261.372 34.0615 260.307 33.7837 259.27L31.878 252.158C30.5296 247.125 25.3569 244.139 20.3245 245.487Z",
    fill: "#FF453A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3222 257.037C21.3222 257.037 21.9895 257.484 23.3015 257.132C24.6135 256.781 24.9678 256.06 24.9678 256.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0773,
    cy: 255.976,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 17.0773 255.976)",
    fill: "#1F1F23"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3352,
    cy: 255.547,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 16.3352 255.547)",
    fill: "#D9D9D9"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2211,
    cy: 252.99,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 28.2211 252.99)",
    fill: "#1F1F23"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.479,
    cy: 252.561,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 27.479 252.561)",
    fill: "#D9D9D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0563 257.244L31.879 261.944L33.2073 271.878M33.2073 271.878L31.879 273.544M33.2073 271.878V274.734M33.2073 271.878L35.5016 273.544",
    stroke: "#FF453A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 260.651C96.5 249.605 105.454 240.651 116.5 240.651C127.546 240.651 136.5 249.605 136.5 260.651C136.5 271.697 127.546 280.651 116.5 280.651C105.454 280.651 96.5 271.697 96.5 260.651Z",
    fill: "#90A8C1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 260.651C96.5 249.605 105.454 240.651 116.5 240.651C127.546 240.651 136.5 249.605 136.5 260.651C136.5 271.697 127.546 280.651 116.5 280.651C105.454 280.651 96.5 271.697 96.5 260.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 260.651C144.5 249.605 153.454 240.651 164.5 240.651C175.546 240.651 184.5 249.605 184.5 260.651C184.5 271.697 175.546 280.651 164.5 280.651C153.454 280.651 144.5 271.697 144.5 260.651Z",
    fill: "#90A8C1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 260.651C144.5 249.605 153.454 240.651 164.5 240.651C175.546 240.651 184.5 249.605 184.5 260.651C184.5 271.697 175.546 280.651 164.5 280.651C153.454 280.651 144.5 271.697 144.5 260.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 260.651C192.5 249.605 201.454 240.651 212.5 240.651C223.546 240.651 232.5 249.605 232.5 260.651C232.5 271.697 223.546 280.651 212.5 280.651C201.454 280.651 192.5 271.697 192.5 260.651Z",
    fill: "#90A8C1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 260.651C192.5 249.605 201.454 240.651 212.5 240.651C223.546 240.651 232.5 249.605 232.5 260.651C232.5 271.697 223.546 280.651 212.5 280.651C201.454 280.651 192.5 271.697 192.5 260.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 260.651C240.5 249.605 249.454 240.651 260.5 240.651C271.546 240.651 280.5 249.605 280.5 260.651C280.5 271.697 271.546 280.651 260.5 280.651C249.454 280.651 240.5 271.697 240.5 260.651Z",
    fill: "#90A8C1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 260.651C240.5 249.605 249.454 240.651 260.5 240.651C271.546 240.651 280.5 249.605 280.5 260.651C280.5 271.697 271.546 280.651 260.5 280.651C249.454 280.651 240.5 271.697 240.5 260.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 260.651C288.5 249.605 297.454 240.651 308.5 240.651C319.546 240.651 328.5 249.605 328.5 260.651C328.5 271.697 319.546 280.651 308.5 280.651C297.454 280.651 288.5 271.697 288.5 260.651Z",
    fill: "#90A8C1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 260.651C288.5 249.605 297.454 240.651 308.5 240.651C319.546 240.651 328.5 249.605 328.5 260.651C328.5 271.697 319.546 280.651 308.5 280.651C297.454 280.651 288.5 271.697 288.5 260.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 308.651C0.5 297.605 9.45431 288.651 20.5 288.651C31.5457 288.651 40.5 297.605 40.5 308.651C40.5 319.697 31.5457 328.651 20.5 328.651C9.45431 328.651 0.5 319.697 0.5 308.651Z",
    fill: "#90A8C1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 308.651C0.5 297.605 9.45431 288.651 20.5 288.651C31.5457 288.651 40.5 297.605 40.5 308.651C40.5 319.697 31.5457 328.651 20.5 328.651C9.45431 328.651 0.5 319.697 0.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 308.651C48.5 297.605 57.4543 288.651 68.5 288.651C79.5457 288.651 88.5 297.605 88.5 308.651C88.5 319.697 79.5457 328.651 68.5 328.651C57.4543 328.651 48.5 319.697 48.5 308.651Z",
    fill: "#90A8C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 308.651C48.5 297.605 57.4543 288.651 68.5 288.651C79.5457 288.651 88.5 297.605 88.5 308.651C88.5 319.697 79.5457 328.651 68.5 328.651C57.4543 328.651 48.5 319.697 48.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 308.651C96.5 297.605 105.454 288.651 116.5 288.651C127.546 288.651 136.5 297.605 136.5 308.651C136.5 319.697 127.546 328.651 116.5 328.651C105.454 328.651 96.5 319.697 96.5 308.651Z",
    fill: "#90A8C1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 308.651C96.5 297.605 105.454 288.651 116.5 288.651C127.546 288.651 136.5 297.605 136.5 308.651C136.5 319.697 127.546 328.651 116.5 328.651C105.454 328.651 96.5 319.697 96.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 308.651C144.5 297.605 153.454 288.651 164.5 288.651C175.546 288.651 184.5 297.605 184.5 308.651C184.5 319.697 175.546 328.651 164.5 328.651C153.454 328.651 144.5 319.697 144.5 308.651Z",
    fill: "#90A8C1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 308.651C144.5 297.605 153.454 288.651 164.5 288.651C175.546 288.651 184.5 297.605 184.5 308.651C184.5 319.697 175.546 328.651 164.5 328.651C153.454 328.651 144.5 319.697 144.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 308.651C192.5 297.605 201.454 288.651 212.5 288.651C223.546 288.651 232.5 297.605 232.5 308.651C232.5 319.697 223.546 328.651 212.5 328.651C201.454 328.651 192.5 319.697 192.5 308.651Z",
    fill: "#90A8C1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 308.651C192.5 297.605 201.454 288.651 212.5 288.651C223.546 288.651 232.5 297.605 232.5 308.651C232.5 319.697 223.546 328.651 212.5 328.651C201.454 328.651 192.5 319.697 192.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M263.477 305.001L256.654 309.701L248.22 298.659M248.22 298.659L248.659 295.892M248.22 298.659L246.351 296.985M248.22 298.659H245.501",
    stroke: "#C780FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M263.961 308.888L260.317 317.07L263.961 326.256H260.317",
    stroke: "#C780FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M265.903 308.888L267.968 317.07L265.903 326.256H269.547",
    stroke: "#C780FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M260.325 293.487C255.292 294.836 252.306 300.008 253.654 305.041L255.56 312.153C255.838 313.19 256.903 313.805 257.94 313.527C259.136 313.206 260.333 312.886 261.529 312.565L268.82 310.612C270.017 310.291 271.213 309.97 272.41 309.65C273.446 309.372 274.062 308.307 273.784 307.27L271.878 300.158C270.53 295.125 265.357 292.139 260.325 293.487Z",
    fill: "#C780FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M261.322 305.037C261.322 305.037 261.989 305.484 263.301 305.132C264.613 304.781 264.968 304.06 264.968 304.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.077,
    cy: 303.976,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 257.077 303.976)",
    fill: "#1F1F23"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.335,
    cy: 303.547,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 256.335 303.547)",
    fill: "#D9D9D9"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.221,
    cy: 300.99,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 268.221 300.99)",
    fill: "#1F1F23"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.479,
    cy: 300.561,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 267.479 300.561)",
    fill: "#D9D9D9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M265.056 305.244L271.879 309.944L273.207 319.878M273.207 319.878L271.879 321.544M273.207 319.878V322.734M273.207 319.878L275.502 321.544",
    stroke: "#C780FF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 308.651C288.5 297.605 297.454 288.651 308.5 288.651C319.546 288.651 328.5 297.605 328.5 308.651C328.5 319.697 319.546 328.651 308.5 328.651C297.454 328.651 288.5 319.697 288.5 308.651Z",
    fill: "#90A8C1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 308.651C288.5 297.605 297.454 288.651 308.5 288.651C319.546 288.651 328.5 297.605 328.5 308.651C328.5 319.697 319.546 328.651 308.5 328.651C297.454 328.651 288.5 319.697 288.5 308.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 356.651C48.5 345.605 57.4543 336.651 68.5 336.651C79.5457 336.651 88.5 345.605 88.5 356.651C88.5 367.697 79.5457 376.651 68.5 376.651C57.4543 376.651 48.5 367.697 48.5 356.651Z",
    fill: "#90A8C1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 356.651C48.5 345.605 57.4543 336.651 68.5 336.651C79.5457 336.651 88.5 345.605 88.5 356.651C88.5 367.697 79.5457 376.651 68.5 376.651C57.4543 376.651 48.5 367.697 48.5 356.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 356.651C96.5 345.605 105.454 336.651 116.5 336.651C127.546 336.651 136.5 345.605 136.5 356.651C136.5 367.697 127.546 376.651 116.5 376.651C105.454 376.651 96.5 367.697 96.5 356.651Z",
    fill: "#90A8C1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 356.651C96.5 345.605 105.454 336.651 116.5 336.651C127.546 336.651 136.5 345.605 136.5 356.651C136.5 367.697 127.546 376.651 116.5 376.651C105.454 376.651 96.5 367.697 96.5 356.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 356.651C192.5 345.605 201.454 336.651 212.5 336.651C223.546 336.651 232.5 345.605 232.5 356.651C232.5 367.697 223.546 376.651 212.5 376.651C201.454 376.651 192.5 367.697 192.5 356.651Z",
    fill: "#90A8C1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 356.651C192.5 345.605 201.454 336.651 212.5 336.651C223.546 336.651 232.5 345.605 232.5 356.651C232.5 367.697 223.546 376.651 212.5 376.651C201.454 376.651 192.5 367.697 192.5 356.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 356.651C240.5 345.605 249.454 336.651 260.5 336.651C271.546 336.651 280.5 345.605 280.5 356.651C280.5 367.697 271.546 376.651 260.5 376.651C249.454 376.651 240.5 367.697 240.5 356.651Z",
    fill: "#90A8C1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 356.651C240.5 345.605 249.454 336.651 260.5 336.651C271.546 336.651 280.5 345.605 280.5 356.651C280.5 367.697 271.546 376.651 260.5 376.651C249.454 376.651 240.5 367.697 240.5 356.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 356.651C288.5 345.605 297.454 336.651 308.5 336.651C319.546 336.651 328.5 345.605 328.5 356.651C328.5 367.697 319.546 376.651 308.5 376.651C297.454 376.651 288.5 367.697 288.5 356.651Z",
    fill: "#90A8C1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 356.651C288.5 345.605 297.454 336.651 308.5 336.651C319.546 336.651 328.5 345.605 328.5 356.651C328.5 367.697 319.546 376.651 308.5 376.651C297.454 376.651 288.5 367.697 288.5 356.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 404.651C0.5 393.605 9.45431 384.651 20.5 384.651C31.5457 384.651 40.5 393.605 40.5 404.651C40.5 415.697 31.5457 424.651 20.5 424.651C9.45431 424.651 0.5 415.697 0.5 404.651Z",
    fill: "#90A8C1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 404.651C0.5 393.605 9.45431 384.651 20.5 384.651C31.5457 384.651 40.5 393.605 40.5 404.651C40.5 415.697 31.5457 424.651 20.5 424.651C9.45431 424.651 0.5 415.697 0.5 404.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 404.651C48.5 393.605 57.4543 384.651 68.5 384.651C79.5457 384.651 88.5 393.605 88.5 404.651C88.5 415.697 79.5457 424.651 68.5 424.651C57.4543 424.651 48.5 415.697 48.5 404.651Z",
    fill: "#90A8C1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 404.651C48.5 393.605 57.4543 384.651 68.5 384.651C79.5457 384.651 88.5 393.605 88.5 404.651C88.5 415.697 79.5457 424.651 68.5 424.651C57.4543 424.651 48.5 415.697 48.5 404.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M119.477 401.001L112.654 405.701L104.22 394.659M104.22 394.659L104.659 391.892M104.22 394.659L102.351 392.985M104.22 394.659H101.501",
    stroke: "#57ADFF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M119.961 404.888L116.317 413.07L119.961 422.256H116.317",
    stroke: "#57ADFF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M121.903 404.888L123.968 413.07L121.903 422.256H125.547",
    stroke: "#57ADFF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M116.325 389.487C111.292 390.836 108.306 396.008 109.654 401.041L111.56 408.153C111.838 409.19 112.903 409.805 113.94 409.527C115.136 409.206 116.333 408.886 117.529 408.565L124.82 406.612C126.017 406.291 127.213 405.97 128.41 405.65C129.446 405.372 130.062 404.307 129.784 403.27L127.878 396.158C126.53 391.125 121.357 388.139 116.325 389.487Z",
    fill: "#57ADFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.322 401.037C117.322 401.037 117.989 401.484 119.301 401.132C120.613 400.781 120.968 400.06 120.968 400.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.077,
    cy: 399.976,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 113.077 399.976)",
    fill: "#1F1F23"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.335,
    cy: 399.547,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 112.335 399.547)",
    fill: "#D9D9D9"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.221,
    cy: 396.99,
    rx: 1.51808,
    ry: 1.51822,
    transform: "rotate(-15 124.221 396.99)",
    fill: "#1F1F23"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.479,
    cy: 396.561,
    rx: 0.303615,
    ry: 0.303644,
    transform: "rotate(-15 123.479 396.561)",
    fill: "#D9D9D9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M121.056 401.244L127.879 405.944L129.207 415.878M129.207 415.878L127.879 417.544M129.207 415.878V418.734M129.207 415.878L131.502 417.544",
    stroke: "#57ADFF",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 404.651C144.5 393.605 153.454 384.651 164.5 384.651C175.546 384.651 184.5 393.605 184.5 404.651C184.5 415.697 175.546 424.651 164.5 424.651C153.454 424.651 144.5 415.697 144.5 404.651Z",
    fill: "#90A8C1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 404.651C144.5 393.605 153.454 384.651 164.5 384.651C175.546 384.651 184.5 393.605 184.5 404.651C184.5 415.697 175.546 424.651 164.5 424.651C153.454 424.651 144.5 415.697 144.5 404.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 404.651C192.5 393.605 201.454 384.651 212.5 384.651C223.546 384.651 232.5 393.605 232.5 404.651C232.5 415.697 223.546 424.651 212.5 424.651C201.454 424.651 192.5 415.697 192.5 404.651Z",
    fill: "#90A8C1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 404.651C192.5 393.605 201.454 384.651 212.5 384.651C223.546 384.651 232.5 393.605 232.5 404.651C232.5 415.697 223.546 424.651 212.5 424.651C201.454 424.651 192.5 415.697 192.5 404.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 404.651C240.5 393.605 249.454 384.651 260.5 384.651C271.546 384.651 280.5 393.605 280.5 404.651C280.5 415.697 271.546 424.651 260.5 424.651C249.454 424.651 240.5 415.697 240.5 404.651Z",
    fill: "#90A8C1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 404.651C240.5 393.605 249.454 384.651 260.5 384.651C271.546 384.651 280.5 393.605 280.5 404.651C280.5 415.697 271.546 424.651 260.5 424.651C249.454 424.651 240.5 415.697 240.5 404.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5234 449.001L24.3461 453.701L32.7797 442.659M32.7797 442.659L32.3413 439.892M32.7797 442.659L34.6489 440.985M32.7797 442.659H35.4991",
    stroke: "#5FFA5C",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 452.888L20.6829 461.07L17.0391 470.256H20.6829",
    stroke: "#5FFA5C",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0968 452.888L13.0321 461.07L15.0968 470.256H11.4531",
    stroke: "#5FFA5C",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6755 437.487C25.7079 438.836 28.6944 444.008 27.3459 449.041L25.4402 456.153C25.1624 457.19 24.0968 457.805 23.0601 457.527C21.8637 457.206 20.6673 456.886 19.4708 456.565L12.1797 454.612C10.9833 454.291 9.78682 453.97 8.59039 453.65C7.5537 453.372 6.93847 452.307 7.21626 451.27L9.12197 444.158C10.4704 439.125 15.6431 436.139 20.6755 437.487Z",
    fill: "#5FFA5C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6778 449.037C19.6778 449.037 19.0105 449.484 17.6985 449.132C16.3865 448.781 16.0322 448.06 16.0322 448.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 25.782 446.903)",
    fill: "#1F1F23"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 25.0366 447.333)",
    fill: "#D9D9D9"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 14.6382 443.917)",
    fill: "#1F1F23"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 13.8928 444.346)",
    fill: "#D9D9D9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9437 449.244L9.12104 453.944L7.79273 463.878M7.79273 463.878L9.12104 465.544M7.79273 463.878V466.734M7.79273 463.878L5.49838 465.544",
    stroke: "#5FFA5C",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 452.651C48.5 441.605 57.4543 432.651 68.5 432.651C79.5457 432.651 88.5 441.605 88.5 452.651C88.5 463.697 79.5457 472.651 68.5 472.651C57.4543 472.651 48.5 463.697 48.5 452.651Z",
    fill: "#90A8C1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 452.651C48.5 441.605 57.4543 432.651 68.5 432.651C79.5457 432.651 88.5 441.605 88.5 452.651C88.5 463.697 79.5457 472.651 68.5 472.651C57.4543 472.651 48.5 463.697 48.5 452.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 452.651C96.5 441.605 105.454 432.651 116.5 432.651C127.546 432.651 136.5 441.605 136.5 452.651C136.5 463.697 127.546 472.651 116.5 472.651C105.454 472.651 96.5 463.697 96.5 452.651Z",
    fill: "#90A8C1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 452.651C96.5 441.605 105.454 432.651 116.5 432.651C127.546 432.651 136.5 441.605 136.5 452.651C136.5 463.697 127.546 472.651 116.5 472.651C105.454 472.651 96.5 463.697 96.5 452.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 452.651C144.5 441.605 153.454 432.651 164.5 432.651C175.546 432.651 184.5 441.605 184.5 452.651C184.5 463.697 175.546 472.651 164.5 472.651C153.454 472.651 144.5 463.697 144.5 452.651Z",
    fill: "#90A8C1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 452.651C144.5 441.605 153.454 432.651 164.5 432.651C175.546 432.651 184.5 441.605 184.5 452.651C184.5 463.697 175.546 472.651 164.5 472.651C153.454 472.651 144.5 463.697 144.5 452.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M209.523 449.001L216.346 453.701L224.78 442.659M224.78 442.659L224.341 439.892M224.78 442.659L226.649 440.985M224.78 442.659H227.499",
    stroke: "#FF9F0A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M209.039 452.888L212.683 461.07L209.039 470.256H212.683",
    stroke: "#FF9F0A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M207.097 452.888L205.032 461.07L207.097 470.256H203.453",
    stroke: "#FF9F0A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M212.675 437.487C217.708 438.836 220.694 444.008 219.346 449.041L217.44 456.153C217.162 457.19 216.097 457.805 215.06 457.527C213.864 457.206 212.667 456.886 211.471 456.565L204.18 454.612C202.983 454.291 201.787 453.97 200.59 453.65C199.554 453.372 198.938 452.307 199.216 451.27L201.122 444.158C202.47 439.125 207.643 436.139 212.675 437.487Z",
    fill: "#FF9F0A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M211.678 449.037C211.678 449.037 211.011 449.484 209.699 449.132C208.387 448.781 208.032 448.06 208.032 448.06",
    stroke: "#1F1F23",
    strokeWidth: 0.674089,
    strokeLinecap: "round"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 217.782 446.903)",
    fill: "#1F1F23"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 217.037 447.333)",
    fill: "#D9D9D9"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.51808,
    cy: 1.51822,
    rx: 1.51808,
    ry: 1.51822,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 206.638 443.917)",
    fill: "#1F1F23"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.303615,
    cy: 0.303644,
    rx: 0.303615,
    ry: 0.303644,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 205.893 444.346)",
    fill: "#D9D9D9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M207.944 449.244L201.121 453.944L199.793 463.878M199.793 463.878L201.121 465.544M199.793 463.878V466.734M199.793 463.878L197.498 465.544",
    stroke: "#FF9F0A",
    strokeWidth: 0.728745,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 452.651C240.5 441.605 249.454 432.651 260.5 432.651C271.546 432.651 280.5 441.605 280.5 452.651C280.5 463.697 271.546 472.651 260.5 472.651C249.454 472.651 240.5 463.697 240.5 452.651Z",
    fill: "#90A8C1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 452.651C240.5 441.605 249.454 432.651 260.5 432.651C271.546 432.651 280.5 441.605 280.5 452.651C280.5 463.697 271.546 472.651 260.5 472.651C249.454 472.651 240.5 463.697 240.5 452.651Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 452.651C288.5 441.605 297.454 432.651 308.5 432.651C319.546 432.651 328.5 441.605 328.5 452.651C328.5 463.697 319.546 472.651 308.5 472.651C297.454 472.651 288.5 463.697 288.5 452.651Z",
    fill: "#90A8C1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 452.651C288.5 441.605 297.454 432.651 308.5 432.651C319.546 432.651 328.5 441.605 328.5 452.651C328.5 463.697 319.546 472.651 308.5 472.651C297.454 472.651 288.5 463.697 288.5 452.651Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageGameImage);
export default __webpack_public_path__ + "static/media/HomePageGameImage.9cdb8008fbfc955a24f336c6a94b3e4e.svg";
export { ForwardRef as ReactComponent };